import { IdModel } from '../models/id-model.interface';

export function GetNextId(elements: IdModel[], prefix: string): { id: string; value: string } {
  const regex = new RegExp(`^${prefix}_(\\d+)$`);
  const maxId = Math.max(
    0,
    ...elements.map((element) => {
      const match = element.id.match(regex);
      return match ? parseInt(match[1], 10) : 0;
    })
  );
  return { id: `${prefix}_${maxId + 1}`, value: `${maxId + 1}` };
}
